<ng-container *ngIf="isLoading; else loadedTemplate">
  <ng-container *ngIf="onlyIcon; else completeTemplate">
    <div class="spinner onlyIcon">
      <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
    </div>
  </ng-container>
  <ng-template #completeTemplate>
    <div class="spinner">
      <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
      <p>{{ 'COMMONS.LOADING' | i18nextEager }}...</p>
    </div>
  </ng-template>
</ng-container>

<ng-template #loadedTemplate>
  <ng-content></ng-content>
</ng-template>
